import type { JSX } from 'react'

import { ChannelSelectionSection } from '~publish/components/Composer/components/ChannelSelectionSection'
import { PreviewChannelSelectionView } from '~publish/legacy/composer/composer/components/channel-selection/PreviewChannelSelectionView'
import type { PreviewChannelSelectionItem } from '~publish/legacy/composer/composer/components/channel-selection/PreviewChannelSelectionView'
import {
  GUEST_NETWORKS,
  getGuestNetworkService,
  normalizeGuestNetworks,
} from '~publish/helpers/guestNetworks'
import type { GuestNetworkId } from '~publish/helpers/guestNetworks'

const GUEST_CHANNELS: readonly PreviewChannelSelectionItem[] =
  GUEST_NETWORKS.map((network) => ({
    id: network.id,
    service: getGuestNetworkService(network),
    label: network.name,
  }))

export function PublicChannelSelector({
  selectedNetworks,
  onChange,
}: {
  selectedNetworks: readonly GuestNetworkId[]
  onChange: (networks: readonly GuestNetworkId[]) => void
}): JSX.Element {
  return (
    <ChannelSelectionSection>
      <PreviewChannelSelectionView
        channels={GUEST_CHANNELS}
        selectedIds={new Set(selectedNetworks)}
        overflow="scroll"
        onToggle={(channelId): void => {
          onChange(
            normalizeGuestNetworks(
              selectedNetworks.some((id) => id === channelId)
                ? selectedNetworks.filter((id) => id !== channelId)
                : [...selectedNetworks, channelId],
            ),
          )
        }}
      />
    </ChannelSelectionSection>
  )
}
